import type { ChangelogAdvancedPayload } from "./changelog-advanced.model";

/** Structured changelog for Snoots PMS v1.44.0 (advanced template). */
export const CHANGELOG_ADVANCED_PAYLOAD_V144: ChangelogAdvancedPayload = {
  titleKey: "changelog.advanced.title",
  subtitleKey: "changelog.advanced.subtitle.v144",
  brandKey: "changelog.advanced.brand.pms",
  helpCenterLabelKey: "changelog.advanced.helpCenter",
  helpCenterUrl: "https://helpcenter.snoots.pet/",
  footnoteKey: "changelog.advanced.footer.v144",
  stats: [
    {
      value: 8,
      labelKey: "changelog.advanced.stat.ux",
      accentColor: "#5F5E5A"
    },
    {
      value: 4,
      labelKey: "changelog.advanced.stat.agenda",
      accentColor: "#0F6E56"
    },
    {
      value: 2,
      labelKey: "changelog.advanced.stat.users",
      accentColor: "#185FA5"
    },
    {
      value: 4,
      labelKey: "changelog.advanced.stat.invoicing",
      accentColor: "#BA7517"
    },
    {
      value: 4,
      labelKey: "changelog.advanced.stat.clinica",
      accentColor: "#006288"
    },
    {
      value: 15,
      labelKey: "changelog.advanced.stat.fixesRelease",
      accentColor: "#E24B4A"
    }
  ],
  tabs: [
    {
      id: "ux",
      labelKey: "changelog.advanced.tab.ux",
      count: 8,
      sectionLabelKey: "changelog.advanced.section.ux",
      accentColor: "#5F5E5A",
      kind: "list",
      items: [
        { textKey: "changelog.advanced.v144.ux.2" },
        { textKey: "changelog.advanced.v144.ux.3" },
        { textKey: "changelog.advanced.v144.ux.4" },
        { textKey: "changelog.advanced.v144.ux.5" },
        { textKey: "changelog.advanced.v144.ux.6" },
        { textKey: "changelog.advanced.v144.ux.7" },
        { textKey: "changelog.advanced.v144.ux.8" }
      ]
    },
    {
      id: "agenda",
      labelKey: "changelog.advanced.tab.agenda",
      count: 4,
      sectionLabelKey: "changelog.advanced.section.agenda",
      accentColor: "#0F6E56",
      kind: "list",
      items: [
        { textKey: "changelog.advanced.v144.agenda.1" },
        { textKey: "changelog.advanced.v144.agenda.2" },
        { textKey: "changelog.advanced.v144.agenda.3" },
        { textKey: "changelog.advanced.v144.agenda.4" }
      ]
    },
    {
      id: "utenti",
      labelKey: "changelog.advanced.tab.users",
      count: 2,
      sectionLabelKey: "changelog.advanced.section.users",
      accentColor: "#185FA5",
      kind: "list",
      items: [
        { textKey: "changelog.advanced.v144.users.1" },
        { textKey: "changelog.advanced.v144.users.2" }
      ]
    },
    {
      id: "fatturazione",
      labelKey: "changelog.advanced.tab.billing",
      count: 4,
      sectionLabelKey: "changelog.advanced.section.billing",
      accentColor: "#BA7517",
      kind: "list",
      items: [
        { textKey: "changelog.advanced.v144.billing.1" },
        { textKey: "changelog.advanced.v144.billing.2" },
        { textKey: "changelog.advanced.v144.billing.3" },
        { textKey: "changelog.advanced.v144.billing.4" }
      ]
    },
    {
      id: "clinica",
      labelKey: "changelog.advanced.tab.clinica",
      count: 4,
      sectionLabelKey: "changelog.advanced.section.clinica",
      accentColor: "#006288",
      kind: "list",
      items: [
        { textKey: "changelog.advanced.v144.clinica.1" },
        { textKey: "changelog.advanced.v144.clinica.2" },
        { textKey: "changelog.advanced.v144.clinica.3" },
        { textKey: "changelog.advanced.v144.clinica.4" }
      ]
    },
    {
      id: "contatti",
      labelKey: "changelog.advanced.tab.contacts",
      count: 2,
      sectionLabelKey: "changelog.advanced.section.contacts",
      accentColor: "#534AB7",
      kind: "list",
      items: [
        { textKey: "changelog.advanced.v144.contacts.1" },
        { textKey: "changelog.advanced.v144.contacts.2" }
      ]
    },
    {
      id: "magazzino",
      labelKey: "changelog.advanced.tab.inventory",
      count: 3,
      sectionLabelKey: "changelog.advanced.section.inventory",
      accentColor: "#8B5A2B",
      kind: "list",
      items: [
        { textKey: "changelog.advanced.v144.inventory.1" },
        { textKey: "changelog.advanced.v144.inventory.2" },
        { textKey: "changelog.advanced.v144.inventory.3" }
      ]
    },
    {
      id: "connettori",
      labelKey: "changelog.advanced.tab.connectors",
      count: 1,
      sectionLabelKey: "changelog.advanced.section.connectors",
      accentColor: "#534AB7",
      kind: "list",
      items: [{ textKey: "changelog.advanced.v144.connectors.1" }]
    },
    {
      id: "fix",
      labelKey: "changelog.advanced.tab.fixes",
      count: 15,
      sectionLabelKey: "changelog.advanced.v144.fixes.section",
      accentColor: "#E24B4A",
      kind: "fixes-summary",
      fixesSummaryKey: "changelog.advanced.v144.fixes.summary"
    }
  ]
};
